<div class="f-select"
     #select
     *ngIf="{
      label: (label$ | async),
      selectValue: (selectValue$ | async),
      list: (predicateList$ | async)
    } as streams$"
>
  <int-default-input
    #input
    class="f-select__field"
    [placeholder]="placeholder"
    [label]="label"
    (onFocusEvent)="onFocus($event)"
    (onBlurEvent)="onBlur($event)"
    [value]="streams$.label || ''"
    (changeValueEvent)="onInput($event)"
    [hideField]="!isDropped && !!streams$.selectValue"
    [verticalAlign]="verticalAlign"
    autocomplete="off"
  >
    <ng-container ngProjectAs="right-position">
      <ng-content select="right-position"></ng-content>
        <int-dropdown-chevron (onClick)="toggleInputFocusHandler($event)" [isActive]="isDropped"></int-dropdown-chevron>
      </ng-container>
    <ng-container ngProjectAs="left-position">
      <ng-content select="left-position"></ng-content>
    </ng-container>
  </int-default-input>
  <div class="f-select__selected-plug" *ngIf="!isDropped">
    <ng-container *ngIf="previewContent; else preview">
      <ng-content
        *ngTemplateOutlet="
            previewContent;
            context: { $implicit: selectValue$ | async }
          "
      ></ng-content>
    </ng-container>
  </div>
  <ng-container *intInsertAfterViewInit>
    <int-portal-slot
      [targetRef]="select"
      [show]="isDropped"
    >
      <ng-template intPortalSlotTemplate>
        <int-dropdown-area
          class="dropdown"
          [style]="{'--int-dropdown-area-max-height': dropdownHeight}"
          [excludeElementsForClickOutside]="select"
          (clickOutside)="closeDropper()"
          (closeEvent)="closeDropper()"
        >
          <ng-container *ngIf="!dropContent">
            <ul class="dropdown__list"
              [style.maxHeight]="dropdownHeight"
              *ngIf="{
                value: (value$ | async),
                selectIndex: (selectIndex$ | async)
              } as streams">
              <li
                intDropdownAreaItem
                [isActive]="inx === streams?.selectIndex"
                class="dropdown__item"
                *ngFor="let item of (predicateList$ | async); index as inx"
                tabindex="2"
                (mousedown)="onSelect(item)"
              >
                <span
                  class="dropdown__item-label"
                  [intAttrBinding]="[
                    {attr: testingMarkers.mark, value: listItemTestingMark},
                    {attr: testingMarkers.defaultValue, value: item?.value}
                  ]"
                  [class.dropdown__item-label--is-selected]="(inx === streams?.selectIndex)"
                  [class.dropdown__item-label--is-active]="(item.value === streams?.value)"
                >
                  {{ item?.label }}
                </span>
              </li>
            </ul>
          </ng-container>
          <ng-container *ngIf="!dropContent">
            <ng-content
              *ngTemplateOutlet="
              dropContent;
              context: {
                $implicit: {
                  list: streams$.list,
                  onSelect: _onSelect,
                  selectValue: streams$.selectValue
                }
              }
            "
            ></ng-content>
          </ng-container>
          <ng-container *ngIf="(streams$.list || []).length === 0">
            <ng-container *ngIf="emptyContent; else emptyList">
              <ng-content *ngTemplateOutlet="emptyContent"></ng-content>
            </ng-container>
          </ng-container>
        </int-dropdown-area>
      </ng-template>
    </int-portal-slot>
  </ng-container>
</div>

<ng-template #preview>
  <span class="preview" *ngIf="{ value: (selectValue$ | async)} as stream">
    {{
      isPreviewShow ? stream.value?.label : ''
    }}
  </span>
</ng-template>

<ng-template #emptyList>
  <span
    class="dropdown__item-label dropdown__item-label--empty"
    *ngIf="{label: (emptyLabel$ | async)} as stream$">
    {{ stream$.label }}
  </span>
</ng-template>
